<template>
  <div class="app-select-color">
    <div
      v-if="colors"
      v-down-outside="close"
      class="b-input picker-wrap color-item"
      :class="{ open: isOpen }"
      @click="toggle"
    >
      <div class="badge" :style="{ background: selected.color }"></div>
      <div class="name">{{ selected.name }}</div>
      <div class="drop-down-wrap">
        <div class="drop-down">
          <div
            v-for="c in colors"
            :key="c.id"
            class="color-item select-item"
            @click="select(c)"
          >
            <div class="badge" :style="{ background: c.color }"></div>
            <div class="name">{{ c.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';
// eslint-disable-next-line no-unused-vars
import { colors } from 'app/utils/colors';

export default {
  name: 'SelectColor',
  components: {},
  directives: {
    downOutside,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      selected: null,
      colors: null,
      isOpen: false,
    };
  },

  computed: {
    ...mapGetters([]),
  },

  mounted() {
    this.colors = colors;
    if (this.value) {
      this.selected = this.value;
    } else {
      this.selected = this.colors[0];
    }
    this.$emit('input', this.selected);
  },
  methods: {
    select(item) {
      this.selected = item;
      this.$emit('input', this.selected);
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/mixins.scss';

.app-select-color {
  .color-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;

    .badge {
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
    .name {
      margin-left: 10px;
    }
  }

  .select-item {
    &:hover {
      background: #f6f6f6;
    }
  }

  .picker-wrap {
    position: relative;
    border-radius: 6px;
    padding-top: 9px;
    padding-bottom: 9px;
    .drop-down-wrap {
      display: flex;
      position: absolute;
      overflow: hidden;
      z-index: 10;
      border-left: 1px solid #d7e2fe;
      border-right: 1px solid #d7e2fe;
      border-bottom: 1px solid #d7e2fe;

      border-radius: 0 0 6px 6px;
      top: 31px;
      left: -1px;
      width: 100%;
      max-height: 0;
      background: white;
      transition: max-height 0.2s ease-out;
      padding-bottom: 4px;
    }
    .drop-down {
      width: 100%;
      overflow: auto;
      margin-top: 7px;

      @include scrollbar(4px);
    }

    &.open {
      .picker-wrap {
        border-radius: 6px 6px 0 0;
      }
      .drop-down-wrap {
        max-height: 32vh;
        z-index: 20;
      }
    }
  }
}
</style>
